module.exports = __webpack_public_path__ + "travelStaytion-fav-icon.png?8be337f8f548a3339cc10b428c280936";